import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const ArrowDownIconSvg = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.625 6.25L7.5 9.375L4.375 6.25"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowDownIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={ArrowDownIconSvg} {...props} />
);

export default ArrowDownIcon;

ArrowDownIcon.displayName = "ArrowDownIcon";
